import { selectOne } from 'vevet-dom';
import { Component } from '../../../base/Component';
/**
 * A base for scroll event components
 */
export class ScrollEventsBase extends Component {
    constructor(initialProp, init = true) {
        super(initialProp, false);
        // get scroll container
        if (typeof this.prop.container === 'string') {
            this._scrollContainer = selectOne(this.prop.container);
        }
        else {
            this._scrollContainer = this.prop.container;
        }
        // initialize the class
        if (init) {
            this.init();
        }
    }
    _getDefaultProp() {
        return Object.assign(Object.assign({}, super._getDefaultProp()), { container: window, intersectionRoot: false });
    }
    get scrollContainer() {
        return this._scrollContainer;
    }
    get scrollableElement() {
        if (this._scrollContainer instanceof Window) {
            return this._app.html;
        }
        return this._scrollContainer;
    }
    /**
     * Parent of inner elements
     */
    get domParent() {
        const { scrollContainer } = this;
        if (scrollContainer instanceof Window) {
            return this._app.body;
        }
        if (scrollContainer instanceof Element) {
            return scrollContainer;
        }
        return scrollContainer.outer;
    }
    /**
     * Used as a "root" for IntersectionObserver
     */
    get intersectionRoot() {
        if (this.prop.intersectionRoot === false) {
            const { scrollContainer } = this;
            if (scrollContainer instanceof Window) {
                return null;
            }
            if (scrollContainer instanceof Element) {
                return scrollContainer;
            }
            return scrollContainer.outer;
        }
        return this.prop.intersectionRoot;
    }
    /**
     * BoundingRect of 'scrollContainer'
     */
    get scrollContainerBounding() {
        if (this.intersectionRoot) {
            const bounding = this.intersectionRoot.getBoundingClientRect();
            return {
                top: bounding.top,
                left: bounding.left,
                width: bounding.width,
                height: bounding.height,
            };
        }
        return {
            top: 0,
            left: 0,
            width: this._app.viewport.width,
            height: this._app.viewport.height,
        };
    }
}
